import React, { Fragment } from 'react';
import { Layout, Col, Row, Select, Table, Button, Modal } from 'antd';
import { ArrowRightOutlined, DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Bar, Line } from 'react-chartjs-2';

import DashboardTrackingList from './dashboard-tracking-list';
import SpanComponent from '@sharedComponent/span-component';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import Header from '@sharedComponent/header/header';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import {
	showAffiliateUsageChart,
	affiliateReportTable,
	trackingDetails,
	bankCard,
	onlyMERCHANT,
	onlyAFFILIATE,
	showInvitationLink,
} from '@constants';
import { isAuth } from '@helpers';
import moment from 'moment';
import { getMaskAccountNumber } from '@sharedComponent/bank/bank-account-card';
import { AffiliateReportExcelDownload } from '@sharedComponent/excel/excel';
import AppLoader from '@sharedComponent/loaders/app-loader';
import GifLoader from '@sharedComponent/gif-loader';
import CopyLink from './copy-link';
import TermsAndCondition from '@pages/terms-and-conditions/terms-and-conditions-page';
const dateFormat = 'MM/DD/YYYY';

const { Option } = Select;
const { Content } = Layout;

export class DashboardPresentation extends React.Component {
	render() {
		const { reportData, history } = this.props;
		const columns = [
			{
				title: 'AFFILIATE NAME',
				dataIndex: 'sourceTitle',
				key: 'sourceTitle',
				align: 'left',
				width: '25%',
				render: (value, row, index) => {
					const firstLetter = value[0].toUpperCase();
					return (
						<Row align="middle">
							<Col
								className="flc"
								onClick={() => history.push(`/affiliate-management/view-affiliate/${row.sourceId}/${row.clientSourceId}`)}>
								<Col>
									<Col className={`${firstLetter}_text text_box flc`}>
										<Link
											style={{
												color: '#fff',
											}}>
											{firstLetter}
										</Link>
									</Col>
								</Col>
								<Col
									style={{
										cursor: 'pointer',
									}}>
									{value}
								</Col>
							</Col>
						</Row>
					);
				},
				sorter: (a, b) => a.sourceTitle.localeCompare(b.sourceTitle),
			},

			{
				title: 'Campaign',
				dataIndex: 'campaignName',
				align: 'left',
				width: '25%',
				sorter: (a, b) => a.campaignName.localeCompare(b.campaignName),
				key: 'campaignName',
			},
			{
				title: 'Affiliate Id',
				dataIndex: 'clientSourceId',
				width: '25%',
				align: 'left',
				// sorter: (a, b) => a.accountName.localeCompare(b.accountName),
				key: 'clientSourceId',
			},
			{
				title: 'Status',
				dataIndex: 'statusDesc',
				align: 'left',
				width: '25%',
				sorter: (a, b) => a.statusDesc.localeCompare(b.statusDesc),
				key: 'statusDesc',
				render: (value, row, index) => {
					return (
						<Row align="middle">
							<Col className="flc">
								<Col className={`${row.status.toUpperCase()} status_circle`} />
							</Col>
							<Col>{value}</Col>
						</Row>
					);
				},
			},
		];

		const state = this.props.state;
		const bardata = this.props.bardata;
		const bardata1 = this.props.bardata1;
		const linedata = this.props.linedata;
		const bankForm = this.props.bankForm;
		const { commissionProfileData = [] } = this.props;
		const { loading } = state;

		const handleChartDataType = this.props.handleChartDataType;
		const { userDetails, performanceChartLoading, chartLoading, termsModalVisible, closeTermsModal, companyEncryptId } = this.props;
		let profileImage = null;
		let accessLevel = null;
		if (userDetails) {
			profileImage = userDetails.profileImage;
			accessLevel = userDetails.accessLevel;
		}
		const performanceData = this.props.performanceData;
		const commissionData = this.props.commissionData;
		const affiliateData = this.props.affiliateData;

		linedata.labels = performanceData.labels || [];
		let dats = [];
		if (performanceData.datasets.length >= 2) {
			dats.push(performanceData.datasets[0]);
			dats.push(performanceData.datasets[1]);
			linedata.datasets = dats || [];
		} else {
			linedata.datasets = performanceData.datasets || [];
		}

		bardata.labels = commissionData.labels || [];
		let dats1 = [];
		if (commissionData.datasets.length >= 2) {
			dats1.push(commissionData.datasets[0]);
			dats1.push(commissionData.datasets[1]);
			bardata.datasets = dats1 || [];
		} else {
			bardata.datasets = commissionData.datasets || [];
		}

		bardata1.labels = affiliateData.labels || [];
		let dats2 = [];
		if (affiliateData.datasets.length >= 2) {
			dats2.push(affiliateData.datasets[0]);
			dats2.push(affiliateData.datasets[1]);
			bardata1.datasets = dats2 || [];
		} else {
			bardata1.datasets = affiliateData.datasets || [];
		}
		const url = `${window.location.origin}/register/${companyEncryptId ? companyEncryptId : ''}`;

		return (
			<>
				{loading ? (
					<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
						<GifLoader />
						{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					</Col>
				) : (
						<>
							<Modal
								closable={termsModalVisible}
								className="terms_condition_modal"
								visible={termsModalVisible}
								width={'90%'}
								title="Konnektive Terms & Conditions"
								onOk={() => alert('hai')}
								// onCancel={this.handleCancel}
								footer={[
									<Button key="submit" type="primary" onClick={closeTermsModal}>
										I Agree the Terms
								</Button>,
								]}>
								<TermsAndCondition fromDashboard />
							</Modal>
							<Header title="Dashboard" />
							<Content>
								<Row className="user_card" style={{ position: 'relative' }}>
									<Col className="overlay-cover" />
									<ImageComponent
										style={{ position: 'absolute' }}
										className="image_area"
										src={(userDetails && userDetails.coverImage) || images.usercard}
									/>

									<Col xl={6} lg={8} md={24} sm={24} xs={24} className="user_card_img" style={{ zIndex: 1 }}>
										<ImageComponent className="card_userProfile" src={profileImage || images.k} />
									</Col>

									<Col xl={6} lg={8} md={24} sm={24} xs={24} className="card-center_details" style={{ zIndex: 1 }}>
										<Col className="card-center_details_card">
											{isAuth(onlyMERCHANT, accessLevel) ? (
												<>
													<Col className="card_row">
														<Col className="card_label"></Col>
														<Col className="card_value"></Col>
													</Col>
													<Col className="card_row">
														<Col className="card_label"></Col>
														<Col className="card_value"></Col>
													</Col>
													<Col className="card_row">
														<Col className="card_label">Company Name</Col>
														<Col className="card_value">{userDetails && userDetails.businessName}</Col>
													</Col>
													<Col className="card_row">
														<Col className="card_label"></Col>
														<Col className="card_value"></Col>
													</Col>
												</>
											) : (
													<>
														{isAuth(onlyMERCHANT, accessLevel) ? null : (
															<Col className="card_row">
																<Col className="card_label">Company Name</Col>
																<Col className="card_value">{userDetails && userDetails.businessName}</Col>
															</Col>
														)}
														<Col className="card_row">
															<Col className="card_label">Affiliate Name</Col>
															<Col className="card_value">
																{userDetails && userDetails.firstName} {userDetails && userDetails.lastName}
															</Col>
														</Col>
														{isAuth(showInvitationLink, userDetails && userDetails.accessLevel) && (
															<Col className="card_row">
																<Col className="card_label">Invitation Link</Col>
																<CopyLink text="Copy Link" value={url} />
															</Col>
														)}
													</>
												)}
										</Col>
									</Col>

									<Col xl={12} lg={8} md={24} sm={24} xs={24} style={{ zIndex: 1 }}>
										<Col className="Imge_content">
											<Link to="/cover-photo">
												<ImageComponent className="" src={images.camera || images.k} />
											</Link>
										</Col>
									</Col>
								</Row>

								{isAuth(bankCard, userDetails && userDetails.accessLevel) ? (
									<Row>
										<Col xl={10} lg={10} md={24} sm={24} xs={24} className="bank_acc_card">
											<Col className="card_header">
												{bankForm.bankName ? (
													<Col className="card_header_name" style={{ textTransform: 'capitalize' }}>
														{bankForm.bankName}
													</Col>
												) : (
														<Col className="card_header_name" style={{ textTransform: 'capitalize' }}>
															Add Bank Information
														</Col>
													)}
												<Col>
													{' '}
													<Link to="bank-info">
														<ImageComponent className="edit_icon" src={images.edit || images.k} />{' '}
													</Link>
												</Col>
											</Col>
											{bankForm.bankName ? (
												<Col className="card_body">
													<Col className="checking">{bankForm.accountType}</Col>
													<Col className="checking_number">{getMaskAccountNumber(bankForm.accountNumber)}</Col>
												</Col>
											) : (
													<Col className="" style={{ fontSize: '22px', color: 'white', padding: '10px' }}>
														XXXX XXXX XXXX XXXX
													</Col>
													// <Col className="" style={{ fontSize: '20px', color: 'white', padding: '10px' }}>
													// 	No bank account information. Select edit to add a new bank account.
													// </Col>
												)}
										</Col>
										<Col xl={1} lg={1} md={0} sm={0} xs={0}></Col>

										<Col xl={13} lg={13} md={24} sm={24} xs={24} className="commision-profile">
											<Col className="com_header">
												<Col className="card_header_name" style={{ fontSize: 16 }}>
													Commission Profiles
											</Col>
												<Col className="viewAll">
													<SpanComponent>
														<Link
															to={{
																pathname: '/commission-profiles',
																state: commissionProfileData.data,
															}}
															style={{ color: '#253d5c' }}>
															View All
													</Link>
														<SpanComponent style={{ paddingLeft: '10px' }}>
															<ArrowRightOutlined />{' '}
														</SpanComponent>{' '}
													</SpanComponent>{' '}
												</Col>
											</Col>
											<Col className="com_body">
												{commissionProfileData.commissionProfilesLoading ? (
													<Col style={{ display: 'flex', height: '50px', justifyContent: 'center', alignItems: 'center' }}>
														<GifLoader />
													</Col>
												) : commissionProfileData.data.length > 0 ? (
													<table className="com_tab">
														<thead>
															<tr>
																<th colSpan="2">Campaign</th>
																<th>CPC</th>
																<th>Step 1 </th>
																<th>Step 2 </th>
															</tr>
														</thead>
														<tbody>
															{commissionProfileData.data.slice(0, 2).map((campaign, i) => (
																<Fragment key={i}>
																	<tr>
																		<td></td>
																		<td>{campaign.campaignName}</td>
																		<td>${campaign.cpcCommission}</td>
																		<td>${campaign.step1Commission}</td>
																		<td>${campaign.step2Commission} </td>
																	</tr>
																	<Col style={{ margin: '6px' }}></Col>
																</Fragment>
															))}
														</tbody>
													</table>
												) : (
															<Col
																style={{
																	display: 'flex',
																	fontSize: '18px',
																	justifyContent: 'center',
																	alignItems: 'center',
																	fontFamily: 'Gilroy-Semibold',
																	height: '100%',
																}}>
																<span>No Commissions Profiles</span>
															</Col>
														)}
											</Col>
										</Col>
									</Row>
								) : null}

								<Row>
									{isAuth(showAffiliateUsageChart, userDetails && userDetails.accessLevel) && (
										<Col
											style={{ width: '100%', marginTop: '30px' }}
											xl={24}
											lg={24}
											md={24}
											sm={24}
											xs={24}
											className="dashboard_card"
											onClick={() => history.push('/affiliate-usage')}>
											{/* <Col style={{ width: '100%', marginTop: '30px' }} xl={12} lg={12} md={24} sm={24} xs={24}> */}
											<Col className="chart_card_area">
												<Col className="chartlabel">
													<Col className="chartName">
														<Link to="/affiliate-usage">Affiliate Usage</Link>
													</Col>
												</Col>
												<Bar data={bardata1} options={bardata1.options} height={100} legend={bardata1.legend} />
											</Col>
										</Col>
									)}
									<Col
										style={{ width: '100%', marginTop: '30px' }}
										xl={12}
										lg={12}
										md={24}
										sm={24}
										xs={24}
										className="dashboard_card"
										onClick={() => history.push('/commission-report')}>
										<Col className="chart_card_area">
											{chartLoading ? (
												<Col style={{ display: 'flex', height: '355px', justifyContent: 'center', alignItems: 'center' }}>
													<GifLoader />
													{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
												</Col>
											) : (
													<>
														<Col className="chartlabel">
															<Col className="chartName">
																<Link to="/commission-report">Commission Report</Link>
															</Col>
														</Col>
														{bardata.datasets.length > 0 ? (
															<Bar data={bardata} options={bardata.options} legend={bardata.legend} />
														) : (
																<Col
																	style={{
																		height: '80%',
																		display: 'flex',
																		justifyContent: 'center',
																		alignItems: 'center',
																		fontSize: '18px',
																		fontFamily: 'Gilroy-Semibold',
																	}}>
																	No Commissions
																</Col>
															)}
													</>
												)}
										</Col>
									</Col>

									<Col
										style={{ width: '100%', marginTop: '30px' }}
										xl={12}
										lg={24}
										md={24}
										sm={24}
										xs={24}
										className=""
									// onClick={() => history.push('/performance-report')}
									>
										<Col className="chart_card_area">
											{performanceChartLoading ? (
												<Col style={{ display: 'flex', height: '355px', justifyContent: 'center', alignItems: 'center' }}>
													<GifLoader />
													{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
												</Col>
											) : (
													<>
														<Col className="chartlabel" style={{ justifyContent: 'space-between' }}>
															<Col className="chartName">
																<Link to="/performance-report"> Performance Report </Link>
															</Col>
															<Col className="perform_clicks">
																<Select
																	defaultValue={performanceData.chartDataType}
																	onChange={(e) => {
																		handleChartDataType('chartDataType', e);
																	}}
																	style={{ width: 120 }}>
																	<Option value="Clicks">Clicks</Option>
																	<Option value="Sales">Sales</Option>
																	<Option value="Partial">Partial</Option>
																	<Option value="Rebills">Rebills</Option>
																	<Option value="Declines">Declines</Option>
																</Select>
															</Col>
														</Col>
														{linedata.datasets.length > 0 ? (
															<Line data={linedata} options={linedata.options} legend={linedata.legend} />
														) : (
																<Col
																	style={{
																		height: '80%',
																		display: 'flex',
																		fontSize: '18px',
																		justifyContent: 'center',
																		alignItems: 'center',
																		fontFamily: 'Gilroy-Semibold',
																	}}>
																	No Performances
																</Col>
															)}
													</>
												)}
										</Col>
									</Col>
								</Row>
								{isAuth(trackingDetails, userDetails && userDetails.accessLevel) ? (
									<Row style={{ marginTop: '30px' }}>
										<Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
											<Col className="tracking-picks">
												<Col className="tracking_picks_name">Tracking Pixels</Col>
												{Array(4)
													.fill('')
													.map((data, i) => (
														<DashboardTrackingList key={i} />
													))}
											</Col>
										</Col>
									</Row>
								) : null}

								{isAuth(affiliateReportTable, userDetails && userDetails.accessLevel) ? (
									<Row style={{ marginTop: '30px' }}>
										<Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
											<Col className="tracking-picks">
												<Col className="tracking_picks_name" style={{ margin: '5px auto', display: 'inline-block' }}>
													Affiliate Report
											</Col>

												<Col className="export_area" style={{ float: 'right' }}>
													<Button type="primary" className="excel_download" icon={<DownloadOutlined />} size={'middle'}>
														Export to EXCEL
													<AffiliateReportExcelDownload
															style={{ visibility: 'hidden' }}
															dataSet={reportData.reportTableData}
															filename={`${moment(new Date()).format(dateFormat)}_Affiliate_Report`}
														/>
													</Button>
												</Col>
												{reportData.reportLoading ? (
													<Col style={{ display: 'flex', height: '355px', justifyContent: 'center', alignItems: 'center' }}>
														<GifLoader />
														{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
													</Col>
												) : (
														<Table
															className="dashboard_report"
															pagination={{
																position: ['bottomCenter', 'bottomCenter'],
																defaultPageSize: 5,
																showSizeChanger: true,
																pageSizeOptions: ['5', '10'],
															}}
															dataSource={reportData.reportTableData}
															columns={columns}
														/>
													)}
											</Col>
										</Col>
									</Row>
								) : null}
							</Content>
						</>
					)}
			</>
		);
	}
}
